<template>
        <div class="row align-items-end">
            <div class="col">
                <label v-if="withLabels">{{$t('Days')}}</label>
                <b-form-select :size="size" v-model="days" :disabled="disabled" :options="daysOptions"></b-form-select>
            </div>
            <div class="col">
                <label v-if="withLabels">{{$t('Hours')}}</label>
                <b-form-select :size="size" v-model="hours" :disabled="disabled" :options="hoursOptions"></b-form-select>
            </div>
            <div class="col">
                <label v-if="withLabels">{{$t('Minutes')}}</label>
                <b-form-select :size="size" v-model="minutes" :disabled="disabled" :options="minutesOptions"></b-form-select>
            </div>
            <div class="col-3" v-if="canDelete || canAdd">
              <b-button v-if="canDelete" class="mr-2" :size="size" @click="deleteAction(deleteArgs)">
                <i class="fe fe-trash"></i>
              </b-button>
              <b-button v-if="canAdd"  variant="primary" :size="size" @click="addAction(addArgs)">
                <i class="fe fe-plus"></i>
              </b-button>
            </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Array | Number,
        canDelete: Boolean,
        canAdd: Boolean,
        disabled: Boolean,
        step: Number,
        withLabels: Boolean,
        addAction: null,
        addArgs: null,
        deleteAction: null,
        deleteArgs: null,
        size: String,
    },
    data() {
        return {}
    },
    methods: {},
    computed: {
        minutes: {
            get() {
                return this.$secs2dhm(this.value).minutes;
            },

            set(value) {
                let val = this.$dhm2secs(this.days, this.hours, value);
                this.$emit('input', val);
                this.$emit('change', val);
            }
        },
        hours: {
            get() {
                return this.$secs2dhm(this.value).hours;
            },

            set(value) {
                let val = this.$dhm2secs(this.days, value, this.minutes);
                this.$emit('input', val);
                this.$emit('change', val);
            }
        },
        days: {
            get() {
                return this.$secs2dhm(this.value).days;
            },

            set(value) {
                let val = this.$dhm2secs(value, this.hours, this.minutes);
                this.$emit('input', val);
                this.$emit('change', val);
            }
        },

        minutesOptions() {
            let data = [];
            for (let minute = 0; minute < 60; minute += this.step) {
                data.push({ value: minute, text: this.$tc('mins ahead', minute) });
            }
            return data;
        },

        hoursOptions() {
            let data = [];
            for (let hour = 0; hour < 24; hour++) {
                data.push({ value: hour, text: this.$tc('hours ahead', hour) });
            }
            return data;
        },

        daysOptions() {
            let data = [];
            for (let day = 0; day < 7; day++) {
                data.push({ value: day, text: this.$tc('days ahead', day) });
            }
            data = data.concat([{ value: 7, text: this.$tc('weeks ahead') },
            { value: 14, text: this.$tc('weeks ahead', 2) },
            { value: 30, text: this.$tc('months ahead', 1) },
            { value: 60, text: this.$tc('months ahead', 2) },
            { value: 90, text: this.$tc('months ahead', 3) }]);
            return data
        }
    }

}
</script>
